(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("survey-pdf"));
	else if(typeof define === 'function' && define.amd)
		define("SurveyPdfFonts", ["survey-pdf"], factory);
	else if(typeof exports === 'object')
		exports["SurveyPdfFonts"] = factory(require("survey-pdf"));
	else
		root["SurveyPdfFonts"] = factory(root["SurveyPDF"]);
})(this, (__WEBPACK_EXTERNAL_MODULE_survey_pdf__) => {
return 